import EmployeeEmploymentSupervisorComponents from "../components/EmployeeEmploymentSupervisor";
import useEmployeeEmploymentSupervisor from "../hooks/useEmployeeEmploymentSupervisor";

function EmployeeEmploymentSupervisor() {
  const supervisorProps = useEmployeeEmploymentSupervisor();
  return (
    <EmployeeEmploymentSupervisorComponents
      {...supervisorProps}
    />
  );
}

export default EmployeeEmploymentSupervisor;
